
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/announcements/cinch-news/[slug]",
      function () {
        return require("private-next-pages/announcements/cinch-news/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/announcements/cinch-news/[slug]"])
      });
    }
  